import { defineAsyncComponent } from "vue";

export default {
  path: "diagnostics",
  meta: { title: "Diagnostics" },
  component: defineAsyncComponent(() => import("../../pages/diagnostics/index.vue")),
  redirect: "/diagnostics/logs",
  children: [
    {
      path: "accessTools",
      meta: { title: "access-tools" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/access-tools/index.vue")),
    },    
    {
      path: "logs",
      meta: { title: "logs" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/logs/index.vue")),
    },
    {
      path: "cableTest",
      meta: { title: "Cable Test" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/cable-test/index.vue")),
    },
    {
      path: 'portStatistics',
      meta: { title: "Port Statistics" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/port-statistics/index.vue"))
    },
    {
      path: "supportDiagnostics",
      meta: { title: "support-diagnostics" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/support-diagnostics/index.vue")),
    },
    {
      path: 'portMirroring',
      meta: { title: "port-mirroring" },
      component: defineAsyncComponent(() => import("../../pages/diagnostics/port-mirroring/index.vue"))
    } 
  ],
};
